import { render, staticRenderFns } from "./AddorderProucttable.vue?vue&type=template&id=0791ea0a&scoped=true&"
import script from "./AddorderProucttable.vue?vue&type=script&lang=js&"
export * from "./AddorderProucttable.vue?vue&type=script&lang=js&"
import style0 from "./AddorderProucttable.vue?vue&type=style&index=0&id=0791ea0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0791ea0a",
  null
  
)

export default component.exports